<template>
    <div>
        <div class="alert alert-warning" v-if="docNumberFormat.currencyid != corpCurrency">
            <p>
                {{ this.$l10n.__('La devise de votre document est différente de la devise de votre compte, les marges ne seront pas calculées.') }}
            </p>
        </div>

        <creditnote
            class="mb-4"
            v-show="creditnotesLoaded"
            @update="reloadKPI"/>

        <purchase
            class="mb-4"
            v-show="purchasesLoaded"
            @update="reloadKPI"/>

        <expense
            class="mb-4"
            v-if="hasExpensePlugin"
            v-show="expensesLoaded"
            @update="reloadKPI"/>

        <row
            class="mb-4"
            v-show="rowsLoaded"
            @update="reloadKPI"/>

        <custom
            class="mb-4"
            v-show="customsLoaded"
            @update="reloadKPI"/>

        <time-tracking
            v-if="hasTimeTrackingPlugin"
            v-show="timetrackingsLoaded"
            @update="reloadKPI"/>
    </div>
</template>

<script>
    import Creditnote from './margin/Creditnote.vue'
    import Purchase from './margin/Purchase.vue'
    import Expense from './margin/Expense.vue'
    import Row from './margin/Row.vue'
    import Custom from './margin/Custom.vue'
    import TimeTracking from './margin/TimeTracking.vue'
    import { createNamespacedHelpers } from 'vuex'
    
    const { mapState, mapActions } = createNamespacedHelpers('documentOverview')

    export default {
        data() {
            return {
                timerToReloadKPI : null
            }
        },
        computed: {
            ...mapState([
                'docNumberFormat',
                'unitNumberFormat',
                'hasExpensePlugin',
                'hasTimeTrackingPlugin',
                'creditnotesLoaded',
                'purchasesLoaded',
                'expensesLoaded',
                'rowsLoaded',
                'customsLoaded',
                'timetrackingsLoaded'
            ]),
            corpCurrency: function () {
                return App.numformat.currencyid
            }
        },
        methods: {
            reloadKPI: function () {
                if (this.timerToReloadKPI) {
                    clearTimeout(this.timerToReloadKPI)
                    this.timerToReloadKPI = null
                }
                this.timerToReloadKPI = setTimeout(() => {
                    this.getStatistics()
                }, 5000);
            },
            ...mapActions([
                'getStatistics'
            ])
        },
        components: {
            Creditnote,
            Purchase,
            Expense,
            Row,
            Custom,
            TimeTracking
        }
    }
</script>